<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/auth'
import { nextTick, onBeforeMount } from 'vue'
import { usePWAInstall } from '@/composables/usePWAInstall'

// Load the module now so its beforeinstallprompt handler (e.preventDefault) is registered
// before Chrome fires the event — prevents the install icon appearing on non-RCP pages.
usePWAInstall()

const router = useRouter()
const authStore = useAuthStore()

onBeforeMount(async () => {
  await authStore.initializeAuth()
  await router.isReady()
  if (router.currentRoute.value.meta.requiresAuth !== false && !authStore.isAuthenticated && router.currentRoute.value.path !== '/login') {
    router.push('/login')
  }

  // Hide the static pre-app splash (index.html) shown for /rcp/* boot paths, once the
  // real page has had a chance to paint underneath it.
  await nextTick()
  const bootSplash = document.getElementById('rcp-boot-splash')
  if (bootSplash) {
    bootSplash.classList.add('rcp-boot-splash--hide')
    setTimeout(() => bootSplash.remove(), 300)
  }
})
</script>

<template>
  <div>
    <RouterView />
    <Snackbar #default="slotProps">
      <vue3-snackbar bottom :duration="slotProps?.duration" shadow></vue3-snackbar>
    </Snackbar>
  </div>
</template>
